export const mockJobList = {
  context: {
    domain: 'ONDC:ONEST10',
    action: 'on_search',
    version: '2.0.0',
    bap_id: 'worker-hub.bap.io',
    bap_uri: 'https://worker-hub.bap.io',
    bpp_id: 'job-hub.bpp.io',
    bpp_uri: 'https://job-hub.bpp.io',
    transaction_id: 'a9aaecca-10b7-4d19-b640-b047a7c62195',
    message_id: '672f774c-4281-44dd-b1c2-84222a3d771e',
    location: {
      city: {
        code: 'std:080',
      },
      country: {
        code: 'IND',
      },
    },
    timestamp: '2023-02-22T11:45:10.171Z',
    ttl: 'PT30S',
  },
  message: {
    catalog: {
      descriptor: {
        name: 'Affindi Jobs',
      },
      providers: [
        {
          id: '1',
          descriptor: {
            name: 'Affinidi',
            short_desc: 'Short Description about the company',
            images: [
              {
                url: 'url of the image of the provider',
              },
            ],
          },
          fulfillments: [
            {
              id: '1',
              type: 'lead',
            },
            {
              id: '2',
              type: 'recruitment',
            },
            {
              id: '3',
              type: 'lead & recruitment',
            },
          ],
          locations: [
            {
              id: 'L1',
              city: {
                name: 'Pune',
                code: 'std:020',
              },
              state: {
                name: 'Maharastra',
                code: 'MH',
              },
            },
            {
              id: 'L2',
              city: {
                name: 'Thane',
                code: 'std:022',
              },
              state: {
                name: 'Maharastra',
                code: 'MH',
              },
            },
            {
              id: 'L3',
              city: {
                name: 'Lucknow',
                code: 'std:0522',
              },
              state: {
                name: 'Uttar Pradesh',
                code: 'UP',
              },
            },
          ],
          items: [
            {
              id: '0253719F295521CED39EC9C2F3C8DCDE',
              category_ids: ['Software development'],
              descriptor: {
                name: 'Fullstack Engineer',
                long_desc:
                  'We’re on a search for a Staff Mobile Developer with the following attributes: Critical Thinking- You are able to skillfully conceptualise, apply, analyse and evaluate information gathered from observation, experience or communication and use it as a guide to action Data-Driven attitude — You often propose solutions or make a point in a logical and objective manner, substantiated with accurate data and evidence Dealing with Ambiguity — You can effectively cope with change and uncertainty, and are comfortable when things are up in the air Goal-oriented — You are driven and can be counted on to exceed goals. You steadfastly push yourself and others to achieve results all the time Problem Solving — You can easily identify and solve complex problems in a methodological manner',
                short_desc:
                  'We are seeking a Staff Mobile Developer with strong critical thinking, data-driven decision-making, adaptability, goal-orientation, and problem-solving skills.',
                images: [
                  {
                    url: 'images url1',
                  },
                  {
                    url: 'images url2',
                  },
                ],
                media: [
                  {
                    mimetype: 'audio/mp4',
                    url: 'http://url-to-audio-about-job',
                  },
                  {
                    mimetype: 'video/mp4',
                    url: 'http://url-to-video-about-job',
                  },
                ],
              },
              quantity: {
                available: {
                  count: 50,
                },
              },
              time: {
                label: 'enable',
                timestamp: '2023-02-22T11:45:10.171Z',
                range: {
                  start: '2025-01-03T13:23:10.171Z',
                  end: '2025-02-03T13:23:10.171Z',
                },
              },
              location_ids: ['L2'],
              fulfillment_ids: ['1', '2', '3'],
              creator: {
                descriptor: {
                  name: 'Marketplace Connector',
                  code: 'MPC_45',
                  short_desc: 'Connecting Digital Marketplaces',
                  long_desc:
                    'This platform bridges various digital marketplaces, fostering seamless trade and enhancing accessibility for businesses and consumers alike.',
                  media: [
                    {
                      mimetype: 'image/jpeg',
                      url: 'https://marketplace.com/logo.jpg',
                    },
                  ],
                  images: [
                    {
                      url: 'https://marketplace.com/banner.jpg',
                    },
                  ],
                },
                address: 'Level 5, Trade Tower, Mumbai, Maharashtra, India',
                state: {
                  name: 'Maharashtra',
                  code: 'MH',
                },
                city: {
                  name: 'Mumbai',
                  code: 'MUM',
                },
                contact: {
                  phone: '+91-1234567890',
                  email: 'support@marketplace.com',
                },
              },
              tags: [
                {
                  descriptor: {
                    code: 'JOB_PROVIDER_LOCATION',
                    name: 'Job Provider Location',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'ADDRESS',
                        name: 'Address',
                      },
                      value: 'Level 5, Trade Tower, Mumbai, Maharashtra, India',
                    },
                    {
                      descriptor: {
                        code: 'STATE',
                        name: 'State',
                      },
                      value: 'Mumbai',
                    },
                    {
                      descriptor: {
                        code: 'CITY',
                        name: 'City',
                      },
                      value: 'Maharashtra',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'TIMING',
                    name: 'Timing',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DAY_FROM',
                        name: 'Day from',
                      },
                      value: '1',
                    },
                    {
                      descriptor: {
                        code: 'DAY_TO',
                        name: 'Day to',
                      },
                      value: '6',
                    },
                    {
                      descriptor: {
                        code: 'TIME_FROM',
                        name: 'Time from',
                      },
                      value: '0900',
                    },
                    {
                      descriptor: {
                        code: 'TIME_TO',
                        name: 'Time to',
                      },
                      value: '1800',
                    },
                  ],
                },
                //   {
                //     "descriptor": {
                //       "code": "TIMING",
                //       "name": "Timing"
                //     },
                //     "list": [
                //       {
                //         "descriptor": {
                //           "code": "DAY_FROM",
                //           "name": "Day from"
                //         },
                //         "value": "6"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "DAY_TO",
                //           "name": "Day to"
                //         },
                //         "value": "6"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "TIME_FROM",
                //           "name": "Time from"
                //         },
                //         "value": "0900"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "TIME_TO",
                //           "name": "Time to"
                //         },
                //         "value": "1400"
                //       }
                //     ]
                //   },
                //   {
                //     "descriptor": {
                //       "code": "ACADEMIC_ELIGIBILITY",
                //       "name": "Academic eligibility"
                //     },
                //     "list": [
                //       {
                //         "descriptor": {
                //           "code": "COURSE_NAME",
                //           "name": "Name of the course"
                //         },
                //         "value": "Class-X"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "MIN_CGPA",
                //           "name": "Minimum CGPA of marks to be obtained in the course for eligibility"
                //         },
                //         "value": "6.5"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "MANDATORY_ELIGIBILITY",
                //           "name": "Mandatory Eligibility"
                //         },
                //         "value": "false"
                //       }
                //     ]
                //   },
                //   {
                //     "descriptor": {
                //       "code": "ACADEMIC_ELIGIBILITY",
                //       "name": "Academic eligibility"
                //     },
                //     "list": [
                //       {
                //         "descriptor": {
                //           "code": "COURSE_NAME",
                //           "name": "Name of the course"
                //         },
                //         "value": "Class-XII"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "MIN_PERCENTAGE",
                //           "name": "Minimum percentage of marks to be obtained in the course for eligibility"
                //         },
                //         "value": "60"
                //       }
                //     ]
                //   },
                //   {
                //     "descriptor": {
                //       "code": "ACADEMIC_ELIGIBILITY",
                //       "name": "Academic eligibility"
                //     },
                //     "list": [
                //       {
                //         "descriptor": {
                //           "code": "COURSE_LEVEL",
                //           "name": "Level of the course"
                //         },
                //         "value": "Under Graduate"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "MIN_PERCENTAGE",
                //           "name": "Minimum percentage of marks to be obtained in the course for eligibility"
                //         },
                //         "value": "60"
                //       },
                //       {
                //         "descriptor": {
                //           "code": "MANDATORY_ELIGIBILITY",
                //           "name": "Mandatory Eligibility"
                //         },
                //         "value": "false"
                //       }
                //     ]
                //   },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_LEVEL',
                        name: 'Level of the course',
                      },
                      value: 'Graduate',
                    },
                    {
                      descriptor: {
                        code: 'MIN_PERCENTAGE',
                        name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                      },
                      value: '60',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_ELIGIBILITY',
                        name: 'Mandatory Eligibility',
                      },
                      value: 'false',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS_REQUIRED',
                    name: 'Documents Required',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DOCUMENT_NAME',
                        name: 'Name of the document',
                      },
                      value: 'PAN_CARD',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_DOCUMENT',
                        name: 'Mandatory DOCUMENT',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_REQUIREMENTS',
                    name: 'Job requirements',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'REQ_EXPERIENCE',
                        name: 'Required work experience in years',
                      },
                      value: 'P2Y6M',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Skills required for the role',
                      },
                      value: 'android-development',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Skills required for the role',
                      },
                      value: 'dev-ops',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Additional skills required for the job',
                      },
                      value:
                        'You have 8+ years of engineering experience, predominantly in shipping user-facing production features',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_RESPONSIBILITIES',
                    name: 'Job responsibilities',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Build frontend experiences for our tools (Web, PWA and React Native)',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Articulate a long term technical direction and vision for building, maintaining, and scaling our web and mobile platforms',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Create trustworthy user experiences by building interfaces that are simple, easy to comprehend, performant and reliable using modern tools like React, React Native, Typescript, Node.js, Jest and Webpack.',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Mentor and train other team members on design techniques and coding standards.',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_DETAILS',
                    name: 'Listing details',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'INDUSTRY_TYPE',
                        name: 'Industry type',
                      },
                      value: 'IT Services & Consulting',
                    },
                    {
                      descriptor: {
                        code: 'DEPARTMENT',
                        name: 'Department',
                      },
                      value: 'Engineering - Software & QA',
                    },
                    {
                      descriptor: {
                        code: 'EMPLOYMENT_TYPE',
                        name: 'Employment type',
                      },
                      value: 'part-time',
                    },
                    {
                      descriptor: {
                        code: 'WORKING_HOURS',
                        name: 'working hours',
                      },
                      value: '1300-1700',
                    },
                    {
                      descriptor: {
                        code: 'JOB_ROLE',
                        name: 'Job role',
                      },
                      value: 'Fullstack Engineer',
                    },
                    {
                      descriptor: {
                        code: 'JOB_LEVEL',
                        name: 'Job level',
                      },
                      value: 'Mid-level',
                    },
                    {
                      descriptor: {
                        code: 'GENDER',
                        name: 'Gender',
                      },
                      value: 'Male',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'SALARY_INFO',
                    name: 'Salary information',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'GROSS_MIN',
                        name: 'Minimum gross pay',
                      },
                      value: '900000',
                    },
                    {
                      descriptor: {
                        code: 'GROSS_MAX',
                        name: 'Maximum gross pay',
                      },
                      value: '1200000',
                    },
                  ],
                },
                //   {
                //     "descriptor": {
                //       "code": "NP_FEES",
                //       "name": "Np Fees"
                //     },
                //     "list": [
                //       {
                //         "code": "ID",
                //         "value": "1"
                //       },
                //       {
                //         "code": "COMMERCIAL_TYPE",
                //         "value": "percent"
                //       },
                //       {
                //         "code": "COMMERCIAL_VALUE",
                //         "value": "0.5"
                //       },
                //       {
                //         "code": "COMMERCIAL_NAME",
                //         "value": "recruitment"
                //       },
                //       {
                //         "code": "COMMERCIAL_TRIGGERING_STATE",
                //         "value": "OFFER_ACCEPTED"
                //       },
                //       {
                //         "code": "COMPENSATION_TYPE",
                //         "value": "LPA"
                //       },
                //       {
                //         "code": "COMPENSATION_TRANSFER_PERIOD",
                //         "value": "P1M,P2M,P3M"
                //       },
                //       {
                //         "code": "COMPENSATION_PERCENTAGE_SPLIT",
                //         "value": "50,25,25"
                //       }
                //     ]
                //   },
                //   {
                //     "descriptor": {
                //       "code": "NP_FEES",
                //       "name": "Np Fees"
                //     },
                //     "list": [
                //       {
                //         "code": "ID",
                //         "value": "2"
                //       },
                //       {
                //         "code": "COMMERCIAL_TYPE",
                //         "value": "percent"
                //       },
                //       {
                //         "code": "COMMERCIAL_VALUE",
                //         "value": "0.2"
                //       },
                //       {
                //         "code": "COMMERCIAL_NAME",
                //         "value": "lead"
                //       },
                //       {
                //         "code": "COMMERCIAL_TRIGGERING_STATE",
                //         "value": "OFFER_EXTENDED"
                //       },
                //       {
                //         "code": "COMPENSATION_TYPE",
                //         "value": "CTC"
                //       },
                //       {
                //         "code": "COMPENSATION_TRANSFER_PERIOD",
                //         "value": "P1M,P3M,P10M"
                //       },
                //       {
                //         "code": "COMPENSATION_PERCENTAGE_SPLIT",
                //         "value": "25,25,50"
                //       }
                //     ]
                //   },
                //   {
                //     "descriptor": {
                //       "code": "NP_FEES",
                //       "name": "Np Fees"
                //     },
                //     "list": [
                //       {
                //         "code": "ID",
                //         "value": "3"
                //       },
                //       {
                //         "code": "COMMERCIAL_TYPE",
                //         "value": "amount"
                //       },
                //       {
                //         "code": "COMMERCIAL_VALUE",
                //         "value": "300"
                //       },
                //       {
                //         "code": "COMMERCIAL_NAME",
                //         "value": "lead"
                //       },
                //       {
                //         "code": "COMMERCIAL_TRIGGERING_STATE",
                //         "value": "APPLICATION_SUBMITTED"
                //       },
                //       {
                //         "code": "COMPENSATION_TYPE",
                //         "value": "LPA"
                //       },
                //       {
                //         "code": "COMPENSATION_TRANSFER_PERIOD",
                //         "value": "P1M,P2M,P3M"
                //       },
                //       {
                //         "code": "COMPENSATION_PERCENTAGE_SPLIT",
                //         "value": "50,25,25"
                //       }
                //     ]
                //   }
              ],
              price: {
                currency: 'INR',
                value: '1100.00',
                maximum_value: '1200.0',
              },
            },
            {
              id: '34H1BH24GBH4BHH6DF15E62A81C374B4',
              category_ids: ['DevOps'],
              descriptor: {
                name: 'Sr. Devops Engineer',
                long_desc:
                  'We’re on a search for a Staff Mobile Developer with the following attributes: Critical Thinking- You are able to skillfully conceptualise, apply, analyse and evaluate information gathered from observation, experience or communication and use it as a guide to action Data-Driven attitude — You often propose solutions or make a point in a logical and objective manner, substantiated with accurate data and evidence Dealing with Ambiguity — You can effectively cope with change and uncertainty, and are comfortable when things are up in the air Goal-oriented — You are driven and can be counted on to exceed goals. You steadfastly push yourself and others to achieve results all the time Problem Solving — You can easily identify and solve complex problems in a methodological manner',
                short_desc:
                  'We are seeking a Staff Mobile Developer with strong critical thinking, data-driven decision-making, adaptability, goal-orientation, and problem-solving skills.',
                images: [
                  {
                    url: 'images url1',
                  },
                  {
                    url: 'images url2',
                  },
                ],
                media: [
                  {
                    mimetype: 'audio/mp4',
                    url: 'http://url-to-audio-about-job',
                  },
                  {
                    mimetype: 'video/mp4',
                    url: 'http://url-to-video-about-job',
                  },
                ],
              },
              quantity: {
                available: {
                  count: 150,
                },
              },
              location_ids: ['L1'],
              fulfillment_ids: ['1', '2', '3'],
              creator: {
                descriptor: {
                  name: 'Global Trade Hub',
                  code: 'GTH_99',
                  short_desc: 'Facilitating Global Commerce',
                  long_desc:
                    'Global Trade Hub is a platform designed to enable international trade by connecting buyers and sellers across borders with innovative solutions.',
                  media: [
                    {
                      mimetype: 'image/svg+xml',
                      url: 'https://globaltradehub.com/logo.svg',
                    },
                  ],
                  images: [
                    {
                      url: 'https://globaltradehub.com/header-image.jpg',
                    },
                  ],
                },
                address:
                  'Suite 302, International Business Park, New Delhi, India',
                state: {
                  name: 'Delhi',
                  code: 'DL',
                },
                city: {
                  name: 'New Delhi',
                  code: 'NDL',
                },
                contact: {
                  phone: '+91-9988776655',
                  email: 'info@globaltradehub.com',
                },
              },
              time: {
                label: 'enable',
                timestamp: '2023-02-22T11:45:10.171Z',
                range: {
                  start: '2025-01-03T13:23:10.171Z',
                  end: '2025-05-03T13:23:10.171Z',
                },
              },
              tags: [
                {
                  descriptor: {
                    code: 'JOB_PROVIDER_LOCATION',
                    name: 'Job Provider Location',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'ADDRESS',
                        name: 'Address',
                      },
                      value:
                        'Suite 302, International Business Park, New Delhi, India',
                    },
                    {
                      descriptor: null,
                      code: 'STATE',
                      name: 'State',
                      value: 'Delhi',
                    },
                    {
                      descriptor: {
                        code: 'CITY',
                        name: 'City',
                      },
                      value: 'New Delhi',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'TIMING',
                    name: 'Timing',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DAY_FROM',
                        name: 'Day from',
                      },
                      value: '1',
                    },
                    {
                      descriptor: {
                        code: 'DAY_TO',
                        name: 'Day to',
                      },
                      value: '6',
                    },
                    {
                      descriptor: {
                        code: 'TIME_FROM',
                        name: 'Time from',
                      },
                      value: '0900',
                    },
                    {
                      descriptor: {
                        code: 'TIME_TO',
                        name: 'Time to',
                      },
                      value: '1800',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'TIMING',
                    name: 'Timing',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DAY_FROM',
                        name: 'Day from',
                      },
                      value: '6',
                    },
                    {
                      descriptor: {
                        code: 'DAY_TO',
                        name: 'Day to',
                      },
                      value: '6',
                    },
                    {
                      descriptor: {
                        code: 'TIME_FROM',
                        name: 'Time from',
                      },
                      value: '0900',
                    },
                    {
                      descriptor: {
                        code: 'TIME_TO',
                        name: 'Time to',
                      },
                      value: '1400',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_NAME',
                        name: 'Name of the course',
                      },
                      value: 'Class-X',
                    },
                    {
                      descriptor: {
                        code: 'MIN_CGPA',
                        name: 'Minimum CGPA of marks to be obtained in the course for eligibility',
                      },
                      value: '6.5',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_ELIGIBILITY',
                        name: 'Mandatory Eligibility',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_NAME',
                        name: 'Name of the course',
                      },
                      value: 'Class-XII',
                    },
                    {
                      descriptor: {
                        code: 'MIN_PERCENTAGE',
                        name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                      },
                      value: '60',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_LEVEL',
                        name: 'Level of the course',
                      },
                      value: 'Under Graduate',
                    },
                    {
                      descriptor: {
                        code: 'MIN_PERCENTAGE',
                        name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                      },
                      value: '60',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_ELIGIBILITY',
                        name: 'Mandatory Eligibility',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_LEVEL',
                        name: 'Level of the course',
                      },
                      value: 'Graduate',
                    },
                    {
                      descriptor: {
                        code: 'MIN_PERCENTAGE',
                        name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                      },
                      value: '60',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_ELIGIBILITY',
                        name: 'Mandatory Eligibility',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS_REQUIRED',
                    name: 'Documents Required',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DOCUMENT_NAME',
                        name: 'Name of the document',
                      },
                      value: 'AADHAAR_CARD',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_DOCUMENT',
                        name: 'Mandatory DOCUMENT',
                      },
                      value: 'false',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_REQUIREMENTS',
                    name: 'Job requirements',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'REQ_EXPERIENCE',
                        name: 'Required work experience in years',
                      },
                      value: 'P2Y6M',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Skills required for the role',
                      },
                      value: 'pipeline-development',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Skills required for the role',
                      },
                      value: 'dev-ops',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Additional skills required for the job',
                      },
                      value:
                        'You have 8+ years of engineering experience, predominantly in shipping user-facing production features',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_RESPONSIBILITIES',
                    name: 'Job responsibilities',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Build frontend experiences for our tools (Web, PWA and React Native)',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Articulate a long term technical direction and vision for building, maintaining, and scaling our web and mobile platforms',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Create trustworthy user experiences by building interfaces that are simple, easy to comprehend, performant and reliable using modern tools like React, React Native, Typescript, Node.js, Jest and Webpack.',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Mentor and train other team members on design techniques and coding standards.',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_DETAILS',
                    name: 'Listing details',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'INDUSTRY_TYPE',
                        name: 'Industry type',
                      },
                      value: 'IT Services & Consulting',
                    },
                    {
                      descriptor: {
                        code: 'DEPARTMENT',
                        name: 'Department',
                      },
                      value: 'Engineering - Software & QA',
                    },
                    {
                      descriptor: {
                        code: 'EMPLOYMENT_TYPE',
                        name: 'Employment type',
                      },
                      value: 'contractual',
                    },
                    {
                      descriptor: {
                        code: 'WORK_DURATION',
                        name: 'Duration of contract',
                      },
                      value: 'P120D',
                    },
                    {
                      descriptor: {
                        code: 'JOB_ROLE',
                        name: 'Job role',
                      },
                      value: 'Fullstack Engineer',
                    },
                    {
                      descriptor: {
                        code: 'JOB_LEVEL',
                        name: 'Job level',
                      },
                      value: 'Mid-level',
                    },
                    {
                      descriptor: {
                        code: 'GENDER',
                        name: 'Gender',
                      },
                      value: 'Male',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'SALARY_INFO',
                    name: 'Salary information',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'GROSS_MIN',
                        name: 'Minimum gross pay',
                      },
                      value: '900000',
                    },
                    {
                      descriptor: {
                        code: 'GROSS_MAX',
                        name: 'Maximum gross pay',
                      },
                      value: '1200000',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'NP_FEES',
                    name: 'Np Fees',
                  },
                  list: [
                    {
                      code: 'ID',
                      value: '1',
                    },
                    {
                      code: 'COMMERCIAL_TYPE',
                      value: 'percent',
                    },
                    {
                      code: 'COMMERCIAL_VALUE',
                      value: '0.5',
                    },
                    {
                      code: 'COMMERCIAL_NAME',
                      value: 'recruitment',
                    },
                    {
                      code: 'COMMERCIAL_TRIGGERING_STATE',
                      value: 'OFFER_ACCEPTED',
                    },
                    {
                      code: 'COMPENSATION_TYPE',
                      value: 'CTC',
                    },
                    {
                      code: 'COMPENSATION_TRANSFER_PERIOD',
                      value: 'P1M,P3M,P10M',
                    },
                    {
                      code: 'COMPENSATION_PERCENTAGE_SPLIT',
                      value: '25,25,50',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'NP_FEES',
                    name: 'Np Fees',
                  },
                  list: [
                    {
                      code: 'ID',
                      value: '2',
                    },
                    {
                      code: 'COMMERCIAL_TYPE',
                      value: 'percent',
                    },
                    {
                      code: 'COMMERCIAL_VALUE',
                      value: '0.2',
                    },
                    {
                      code: 'COMMERCIAL_NAME',
                      value: 'lead',
                    },
                    {
                      code: 'COMMERCIAL_TRIGGERING_STATE',
                      value: 'OFFER_EXTENDED',
                    },
                    {
                      code: 'COMPENSATION_TYPE',
                      value: 'LPA',
                    },
                    {
                      code: 'COMPENSATION_TRANSFER_PERIOD',
                      value: 'P1M,P2M,P3M',
                    },
                    {
                      code: 'COMPENSATION_PERCENTAGE_SPLIT',
                      value: '50,25,25',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'NP_FEES',
                    name: 'Np Fees',
                  },
                  list: [
                    {
                      code: 'ID',
                      value: '3',
                    },
                    {
                      code: 'COMMERCIAL_TYPE',
                      value: 'amount',
                    },
                    {
                      code: 'COMMERCIAL_VALUE',
                      value: '300',
                    },
                    {
                      code: 'COMMERCIAL_NAME',
                      value: 'lead',
                    },
                    {
                      code: 'COMMERCIAL_TRIGGERING_STATE',
                      value: 'APPLICATION_SUBMITTED',
                    },
                    {
                      code: 'COMPENSATION_TYPE',
                      value: 'CTC',
                    },
                    {
                      code: 'COMPENSATION_TRANSFER_PERIOD',
                      value: 'P1M,P3M,P10M',
                    },
                    {
                      code: 'COMPENSATION_PERCENTAGE_SPLIT',
                      value: '25,25,50',
                    },
                  ],
                },
              ],
              price: {
                currency: 'INR',
                value: '1000.00',
                maximum_value: '1500.0',
              },
            },
            {
              id: '34H1BH24GBH4BHH6DF15E62A81C374B4',
              category_ids: ['DevOps'],
              descriptor: {
                name: 'Jr. Devops Engineer',
                long_desc:
                  'We’re on a search for a Staff Mobile Developer with the following attributes: Critical Thinking- You are able to skillfully conceptualise, apply, analyse and evaluate information gathered from observation, experience or communication and use it as a guide to action Data-Driven attitude — You often propose solutions or make a point in a logical and objective manner, substantiated with accurate data and evidence Dealing with Ambiguity — You can effectively cope with change and uncertainty, and are comfortable when things are up in the air Goal-oriented — You are driven and can be counted on to exceed goals. You steadfastly push yourself and others to achieve results all the time Problem Solving — You can easily identify and solve complex problems in a methodological manner',
                short_desc:
                  'We are seeking a Staff Mobile Developer with strong critical thinking, data-driven decision-making, adaptability, goal-orientation, and problem-solving skills.',
                images: [
                  {
                    url: 'images url1',
                  },
                  {
                    url: 'images url2',
                  },
                ],
                media: [
                  {
                    mimetype: 'audio/mp4',
                    url: 'http://url-to-audio-about-job',
                  },
                  {
                    mimetype: 'video/mp4',
                    url: 'http://url-to-video-about-job',
                  },
                ],
              },
              quantity: {
                available: {
                  count: 150,
                },
              },
              location_ids: ['L1'],
              fulfillment_ids: ['1', '2', '3'],
              creator: {
                descriptor: {
                  name: 'Marketplace Connector',
                  code: 'MPC_45',
                  short_desc: 'Connecting Digital Marketplaces',
                  long_desc:
                    'This platform bridges various digital marketplaces, fostering seamless trade and enhancing accessibility for businesses and consumers alike.',
                  media: [
                    {
                      mimetype: 'image/jpeg',
                      url: 'https://marketplace.com/logo.jpg',
                    },
                  ],
                  images: [
                    {
                      url: 'https://marketplace.com/banner.jpg',
                    },
                  ],
                },
                address: 'Level 5, Trade Tower, Mumbai, Maharashtra, India',
                state: {
                  name: 'Maharashtra',
                  code: 'MH',
                },
                city: {
                  name: 'Mumbai',
                  code: 'MUM',
                },
                contact: {
                  phone: '+91-1234567890',
                  email: 'support@marketplace.com',
                },
              },
              time: {
                label: 'enable',
                timestamp: '2023-02-22T11:45:10.171Z',
                range: {
                  start: '2025-01-03T13:23:10.171Z',
                  end: '2025-05-03T13:23:10.171Z',
                },
              },
              tags: [
                {
                  descriptor: {
                    code: 'JOB_PROVIDER_LOCATION',
                    name: 'Job Provider Location',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'ADDRESS',
                        name: 'Address',
                      },
                      value: 'Level 5, Trade Tower, Mumbai, Maharashtra, India',
                    },
                    {
                      descriptor: {
                        code: 'STATE',
                        name: 'State',
                      },
                      value: 'Mumbai',
                    },
                    {
                      descriptor: {
                        code: 'CITY',
                        name: 'City',
                      },
                      value: 'Maharashtra',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'TIMING',
                    name: 'Timing',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DAY_FROM',
                        name: 'Day from',
                      },
                      value: '1',
                    },
                    {
                      descriptor: {
                        code: 'DAY_TO',
                        name: 'Day to',
                      },
                      value: '6',
                    },
                    {
                      descriptor: {
                        code: 'TIME_FROM',
                        name: 'Time from',
                      },
                      value: '0900',
                    },
                    {
                      descriptor: {
                        code: 'TIME_TO',
                        name: 'Time to',
                      },
                      value: '1800',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'TIMING',
                    name: 'Timing',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DAY_FROM',
                        name: 'Day from',
                      },
                      value: '6',
                    },
                    {
                      descriptor: {
                        code: 'DAY_TO',
                        name: 'Day to',
                      },
                      value: '6',
                    },
                    {
                      descriptor: {
                        code: 'TIME_FROM',
                        name: 'Time from',
                      },
                      value: '0900',
                    },
                    {
                      descriptor: {
                        code: 'TIME_TO',
                        name: 'Time to',
                      },
                      value: '1400',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_NAME',
                        name: 'Name of the course',
                      },
                      value: 'Class-X',
                    },
                    {
                      descriptor: {
                        code: 'MIN_CGPA',
                        name: 'Minimum CGPA of marks to be obtained in the course for eligibility',
                      },
                      value: '6.5',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_ELIGIBILITY',
                        name: 'Mandatory Eligibility',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_NAME',
                        name: 'Name of the course',
                      },
                      value: 'Class-XII',
                    },
                    {
                      descriptor: {
                        code: 'MIN_PERCENTAGE',
                        name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                      },
                      value: '60',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_LEVEL',
                        name: 'Level of the course',
                      },
                      value: 'Under Graduate',
                    },
                    {
                      descriptor: {
                        code: 'MIN_PERCENTAGE',
                        name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                      },
                      value: '60',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_ELIGIBILITY',
                        name: 'Mandatory Eligibility',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'ACADEMIC_ELIGIBILITY',
                    name: 'Academic eligibility',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'COURSE_LEVEL',
                        name: 'Level of the course',
                      },
                      value: 'Graduate',
                    },
                    {
                      descriptor: {
                        code: 'MIN_PERCENTAGE',
                        name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                      },
                      value: '60',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_ELIGIBILITY',
                        name: 'Mandatory Eligibility',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS_REQUIRED',
                    name: 'Documents Required',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DOCUMENT_NAME',
                        name: 'Name of the document',
                      },
                      value: 'AADHAAR_CARD',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_DOCUMENT',
                        name: 'Mandatory DOCUMENT',
                      },
                      value: 'true',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS_REQUIRED',
                    name: 'Documents Required',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DOCUMENT_NAME',
                        name: 'Name of the document',
                      },
                      value: 'PAN_CARD',
                    },
                    {
                      descriptor: {
                        code: 'MANDATORY_DOCUMENT',
                        name: 'Mandatory DOCUMENT',
                      },
                      value: 'false',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_REQUIREMENTS',
                    name: 'Job requirements',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'REQ_EXPERIENCE',
                        name: 'Required work experience in years',
                      },
                      value: 'P6M',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Skills required for the role',
                      },
                      value: 'pipeline-development',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Skills required for the role',
                      },
                      value: 'dev-ops',
                    },
                    {
                      descriptor: {
                        code: 'ADD_PROF_SKILL',
                        name: 'Additional skills required for the job',
                      },
                      value:
                        'You have 8+ years of engineering experience, predominantly in shipping user-facing production features',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_RESPONSIBILITIES',
                    name: 'Job responsibilities',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Build frontend experiences for our tools (Web, PWA and React Native)',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Articulate a long term technical direction and vision for building, maintaining, and scaling our web and mobile platforms',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Create trustworthy user experiences by building interfaces that are simple, easy to comprehend, performant and reliable using modern tools like React, React Native, Typescript, Node.js, Jest and Webpack.',
                    },
                    {
                      descriptor: {
                        code: 'RESPONSIBILITY',
                        name: 'Responsibility',
                      },
                      value:
                        'Mentor and train other team members on design techniques and coding standards.',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'JOB_DETAILS',
                    name: 'Listing details',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'INDUSTRY_TYPE',
                        name: 'Industry type',
                      },
                      value: 'IT Services & Consulting',
                    },
                    {
                      descriptor: {
                        code: 'DEPARTMENT',
                        name: 'Department',
                      },
                      value: 'Engineering - Software & QA',
                    },
                    {
                      descriptor: {
                        code: 'EMPLOYMENT_TYPE',
                        name: 'Employment type',
                      },
                      value: 'full-time',
                    },
                    {
                      descriptor: {
                        code: 'JOB_ROLE',
                        name: 'Job role',
                      },
                      value: 'DevOps Engineer',
                    },
                    {
                      descriptor: {
                        code: 'JOB_LEVEL',
                        name: 'Job level',
                      },
                      value: 'Entry-level',
                    },
                    {
                      descriptor: {
                        code: 'GENDER',
                        name: 'Gender',
                      },
                      value: 'Male',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'SALARY_INFO',
                    name: 'Salary information',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'AVERAGE',
                        name: 'Average gross pay',
                      },
                      value: '900000',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'NP_FEES',
                    name: 'Np Fees',
                  },
                  list: [
                    {
                      code: 'ID',
                      value: '1',
                    },
                    {
                      code: 'COMMERCIAL_TYPE',
                      value: 'percent',
                    },
                    {
                      code: 'COMMERCIAL_VALUE',
                      value: '0.5',
                    },
                    {
                      code: 'COMMERCIAL_NAME',
                      value: 'recruitment',
                    },
                    {
                      code: 'COMMERCIAL_TRIGGERING_STATE',
                      value: 'OFFER_ACCEPTED',
                    },
                    {
                      code: 'COMPENSATION_TYPE',
                      value: 'CTC',
                    },
                    {
                      code: 'COMPENSATION_TRANSFER_PERIOD',
                      value: 'P1M,P3M,P10M',
                    },
                    {
                      code: 'COMPENSATION_PERCENTAGE_SPLIT',
                      value: '25,25,50',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'NP_FEES',
                    name: 'Np Fees',
                  },
                  list: [
                    {
                      code: 'ID',
                      value: '2',
                    },
                    {
                      code: 'COMMERCIAL_TYPE',
                      value: 'percent',
                    },
                    {
                      code: 'COMMERCIAL_VALUE',
                      value: '0.2',
                    },
                    {
                      code: 'COMMERCIAL_NAME',
                      value: 'lead',
                    },
                    {
                      code: 'COMMERCIAL_TRIGGERING_STATE',
                      value: 'OFFER_EXTENDED',
                    },
                    {
                      code: 'COMPENSATION_TYPE',
                      value: 'LPA',
                    },
                    {
                      code: 'COMPENSATION_TRANSFER_PERIOD',
                      value: 'P1M,P2M,P3M',
                    },
                    {
                      code: 'COMPENSATION_PERCENTAGE_SPLIT',
                      value: '50,25,25',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'NP_FEES',
                    name: 'Np Fees',
                  },
                  list: [
                    {
                      code: 'ID',
                      value: '3',
                    },
                    {
                      code: 'COMMERCIAL_TYPE',
                      value: 'amount',
                    },
                    {
                      code: 'COMMERCIAL_VALUE',
                      value: '300',
                    },
                    {
                      code: 'COMMERCIAL_NAME',
                      value: 'lead',
                    },
                    {
                      code: 'COMMERCIAL_TRIGGERING_STATE',
                      value: 'APPLICATION_SUBMITTED',
                    },
                    {
                      code: 'COMPENSATION_TYPE',
                      value: 'CTC',
                    },
                    {
                      code: 'COMPENSATION_TRANSFER_PERIOD',
                      value: 'P1M,P3M,P10M',
                    },
                    {
                      code: 'COMPENSATION_PERCENTAGE_SPLIT',
                      value: '25,25,50',
                    },
                  ],
                },
              ],
              price: {
                currency: 'INR',
                value: '1000.00',
                maximum_value: '1500.0',
              },
            },
          ],
        },
      ],
    },
  },
};

export const mockJobDetails = {
  context: {
    domain: 'ONDC:ONEST10',
    action: 'on_select',
    version: '2.0.0',
    bap_id: 'worker-hub.bap.io',
    bap_uri: 'https://worker-hub.bap.io',
    bpp_id: 'job-hub.bpp.io',
    bpp_uri: 'https://job-hub.bpp.io',
    transaction_id: 'a9aaecca-10b7-4d19-b640-b047a7c62195',
    message_id: 'c8e3968c-cd78-4e46-aa34-0d541e46bd73',
    location: {
      city: {
        code: 'std:080',
      },
      country: {
        code: 'IND',
      },
    },
    timestamp: '2023-02-22T11:50:46.742Z',
    ttl: 'PT30S',
  },
  message: {
    order: {
      provider: {
        id: '1',
      },
      fulfillments: [
        {
          id: '1',
          type: 'lead',
        },
      ],
      items: [
        {
          id: '0253719F295521CED39EC9C2F3C8DCDE',
          fulfillment_ids: ['1'],
          tags: [
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '1',
                },
              ],
            },
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '2',
                },
              ],
            },
          ],
        },
      ],
      quote: {
        price: {
          currency: 'INR',
          value: '1100',
        },
        breakup: [
          {
            id: '0253719F295521CED39EC9C2F3C8DCDE',
            price: {
              currency: 'INR',
              value: '1100',
            },
            title: 'Fullstack Engineer',
            tags: [
              {
                descriptor: {
                  code: 'TYPE',
                },
                list: [
                  {
                    descriptor: {
                      code: 'TYPE',
                    },
                    value: 'item',
                  },
                ],
              },
            ],
          },
        ],
        ttl: 'P1D',
      },
    },
  },
};

export const initJobResponse = {
  context: {
    domain: 'ONDC:ONEST10',
    action: 'on_init',
    version: '2.0.0',
    bap_id: 'worker-hub.bap.io',
    bap_uri: 'https://worker-hub.bap.io',
    bpp_id: 'job-hub.bpp.io',
    bpp_uri: 'https://job-hub.bpp.io',
    transaction_id: 'a9aaecca-10b7-4d19-b640-b047a7c62195',
    message_id: 'af58aa7b-6745-47d0-9b0d-62dcb262ee87',
    location: {
      city: {
        code: 'std:080',
      },
      country: {
        code: 'IND',
      },
    },
    timestamp: '2023-02-23T10:14:051Z',
    ttl: 'PT30S',
  },
  message: {
    order: {
      provider: {
        id: '1',
      },
      items: [
        {
          id: '0253719F295521CED39EC9C2F3C8DCDE',
          fulfillment_ids: ['F3'],
          xinput: {
            required: true,
            head: {
              descriptor: {
                name: 'Application Form',
              },
              index: {
                min: 1,
                cur: 1,
                max: 2,
              },
              headings: ['Candidate Details'],
            },
            form: {
              mime_type: 'text/html',
              url: 'https://6vs8xnx5i7.jobhub.co.in/loans-kyc/xinput/formid/a23f2fdfbbb8ac402bfd54f-1',
              resubmit: false,
            },
          },
          tags: [
            {
              descriptor: {
                code: 'NP_FEES',
              },
              list: [
                {
                  code: 'ID',
                  value: '1',
                },
              ],
            },
            {
              descriptor: {
                code: 'NP_FEES',
              },
              list: [
                {
                  code: 'ID',
                  value: '2',
                },
              ],
            },
          ],
        },
      ],
      quote: {
        price: {
          currency: 'INR',
          value: '1150',
        },
        breakup: [
          {
            item: {
              id: '0253719F295521CED39EC9C2F3C8DCDE',
              price: {
                currency: 'INR',
                value: '1100',
              },
              title: 'item',
            },
          },
          {
            item: {
              id: 'a3a7fe79-f26e-4698-ad0f-874e6b5db085',
              price: {
                currency: 'INR',
                value: '50',
              },
              title: 'tax',
            },
          },
        ],
        ttl: 'P1D',
      },
      fulfillments: [
        {
          id: 'F3',
          type: 'lead & recruitment',
          customer: {
            person: {
              name: 'Sanjay',
              gender: 'Male',
              age: '35',
              skills: [
                {
                  name: 'Android',
                },
                {
                  name: 'AWS',
                },
              ],
              languages: [
                {
                  name: 'en',
                },
                {
                  name: 'ml',
                },
                {
                  name: 'hi',
                },
              ],
              creds: [
                {
                  id: 'D1',
                  descriptor: {
                    name: 'PAN_CARD',
                    short_desc: 'PAN Card information',
                    long_desc: 'Permanent Account Number',
                  },
                  url: 'https://example.com/pan_card.jpeg',
                  type: 'jpeg',
                },
                {
                  id: 'D2',
                  descriptor: {
                    name: 'AADHAAR_CARD',
                    short_desc: 'Aadhaar Card information',
                    long_desc: 'Unique Identification Number',
                  },
                  url: 'https://example.com/aadhaar_card.jpeg',
                  type: 'pdf',
                },
                {
                  id: 'D3',
                  descriptor: {
                    name: 'VOTER_ID',
                    short_desc: 'Voter ID information',
                    long_desc: 'Election Commission ID',
                  },
                  url: 'https://example.com/voter_id.jpeg',
                  type: 'jpeg',
                },
                {
                  id: 'D4',
                  descriptor: {
                    name: 'PASSPORT',
                    short_desc: 'Passport information',
                    long_desc: 'International Travel Document',
                  },
                  url: 'https://example.com/passport.jpeg',
                  type: 'jpeg',
                },
                {
                  id: 'D5',
                  descriptor: {
                    name: 'DRIVING_LICENSE',
                    short_desc: 'Driving License information',
                    long_desc: 'License to Drive',
                  },
                  url: 'https://example.com/driving_license.jpeg',
                  type: 'jpeg',
                },
                {
                  id: 'D6',
                  descriptor: {
                    name: 'RESUME',
                    short_desc:
                      'Summary of qualifications, work experience, and education.',
                    long_desc:
                      "A comprehensive document showcasing an individual's career achievements, skills, work history, education, certifications, and professional experience.",
                  },
                  url: 'https://example.com/resume.pdf',
                  type: 'pdf',
                },
              ],
            },
            contact: {
              phone: '+91-1234567890',
              email: 'abc@abc.bc',
            },
          },
        },
      ],
      payments: [
        {
          status: 'NOT-PAID',
          type: 'ON-ORDER',
          collected_by: 'BAP',
          tags: {
            descriptor: {
              code: 'SETTLEMENT_DETAILS',
            },
            list: [
              {
                descriptor: {
                  code: 'SETTLEMENT_COUNTERPARTY',
                },
                value: 'seller-app',
              },
              {
                descriptor: {
                  code: 'SETTLEMENT_BANK_ACCOUNT_NO',
                },
                value: 'XXXXXXXXXX',
              },
              {
                descriptor: {
                  code: 'SETTLEMENT_IFSC_CODE',
                },
                value: 'XXXXXXXXX',
              },
              {
                descriptor: {
                  code: 'BENEFICIARY_NAME',
                },
                value: 'xxxxx',
              },
              {
                descriptor: {
                  code: 'BANK_NAME',
                },
                value: 'xxxx',
              },
              {
                descriptor: {
                  code: 'BRANCH_NAME',
                },
                value: 'xxxx',
              },
            ],
          },
        },
      ],
    },
  },
};

export const confirmJobResponse = {
  context: {
    domain: 'ONDC:ONEST10',
    action: 'on_confirm',
    version: '2.0.0',
    bap_id: 'worker-hub.bap.io',
    bap_uri: 'https://worker-hub.bap.io',
    bpp_id: 'job-hub.bpp.io',
    bpp_uri: 'https://job-hub.bpp.io',
    transaction_id: 'a9aaecca-10b7-4d19-b640-b047a7c62195',
    message_id: '8cbb5e99-5d06-4855-81e9-a4fc8013dbff',
    location: {
      city: {
        code: 'std:080',
      },
      country: {
        code: 'IND',
      },
    },
    timestamp: '2023-02-23T08:20:06Z',
    ttl: 'PT30S',
  },
  message: {
    order: {
      id: '1677140405881',
      status: 'Created',
      provider: {
        id: '1',
      },
      items: [
        {
          id: '0253719F295521CED39EC9C2F3C8DCDE',
          fulfillment_ids: ['1'],
          tags: [
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '1',
                },
              ],
            },
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '2',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_NAME',
                    name: 'Name of the Course',
                  },
                  value: 'Class-X',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum Percentage of Marks for Eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_NAME',
                    name: 'Name of the Course',
                  },
                  value: 'Class-XII',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum Percentage of Marks for Eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_LEVEL',
                    name: 'Level of the Course',
                  },
                  value: 'Under Graduate',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum Percentage of Marks for Eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_LEVEL',
                    name: 'Level of the Course',
                  },
                  value: 'Graduate',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'false',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_REQUIREMENTS',
                name: 'Job Requirements',
              },
              list: [
                {
                  descriptor: {
                    code: 'REQ_EXPERIENCE',
                    name: 'Required Work Experience in Years',
                  },
                  value: 'P2Y6M',
                },
                {
                  descriptor: {
                    code: 'ADD_PROF_SKILL',
                    name: 'Skills Required for the Role',
                  },
                  value: 'android-development',
                },
                {
                  descriptor: {
                    code: 'ADD_PROF_SKILL',
                    name: 'Skills Required for the Role',
                  },
                  value: 'dev-ops',
                },
                {
                  descriptor: {
                    code: 'REQ_ADDL_SKILL',
                    name: 'Additional Skills Required for the Job',
                  },
                  value:
                    '8+ years of engineering experience in shipping user-facing production features',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_RESPONSIBILITIES',
                name: 'Job Responsibilities',
              },
              list: [
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Build frontend experiences for tools (Web, PWA, React Native)',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value: 'Define long-term technical direction and vision',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Create reliable interfaces using modern tools like React, React Native, Typescript, Node.js, Jest, and Webpack.',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Mentor team members on design techniques and coding standards.',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_DETAILS',
                name: 'Listing Details',
              },
              list: [
                {
                  descriptor: {
                    code: 'INDUSTRY_TYPE',
                    name: 'Industry Type',
                  },
                  value: 'IT Services & Consulting',
                },
                {
                  descriptor: {
                    code: 'DEPARTMENT',
                    name: 'Department',
                  },
                  value: 'Engineering - Software & QA',
                },
                {
                  descriptor: {
                    code: 'EMPLOYMENT_TYPE',
                    name: 'Employment Type',
                  },
                  value: 'Full-Time',
                },
                {
                  descriptor: {
                    code: 'JOB_ROLE',
                    name: 'Job Role',
                  },
                  value: 'DevOps Engineer',
                },
              ],
            },
          ],
        },
      ],
      quote: {
        price: {
          currency: 'INR',
          value: '1700',
        },
        breakup: [
          {
            id: '0253719F295521CED39EC9C2F3C8DCDE',
            price: {
              currency: 'INR',
              value: '1100',
            },
            title: 'Fullstack Engineer',
            tags: [
              {
                descriptor: {
                  code: 'TYPE',
                },
                list: [
                  {
                    descriptor: {
                      code: 'TYPE',
                    },
                    value: 'item',
                  },
                ],
              },
            ],
          },
        ],
        ttl: 'P1D',
      },
      fulfillments: [
        {
          id: '1',
          type: 'lead',
          state: {
            descriptor: {
              code: 'APPLICATION_STARTED',
              name: 'Application Started',
            },
            updated_at: '2023-02-23T08:20:06Z',
          },
          customer: {
            person: {
              name: 'Sanjay',
              gender: 'Male',
              age: '35',
              skills: [
                {
                  code: 'Android',
                  name: 'Android',
                },
                {
                  code: 'AWS',
                  name: 'AWS',
                },
              ],
              languages: [
                {
                  code: 'en',
                  name: 'english',
                },
                {
                  code: 'ml',
                  name: 'Malayalam',
                },
                {
                  code: 'hi',
                  name: 'Hindi',
                },
              ],
              tags: [
                {
                  descriptor: {
                    code: 'CURRENT_EXPERIENCE',
                    name: 'Current Experience',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'EXP_YEARS',
                        name: 'Experience',
                      },
                      value: 'P4Y2M',
                    },
                    {
                      descriptor: {
                        code: 'CURRENT_COMPANY',
                        name: 'Current Company',
                      },
                      value: 'ABC tech',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'SALARY_DETAILS',
                    name: 'Salary Details',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'EXPECTED_SALARY',
                        name: 'Expected Salary',
                      },
                      value: '80000',
                    },
                    {
                      descriptor: {
                        code: 'CURRENT_SALARY',
                        name: 'Current Salary',
                      },
                      value: '50000',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS',
                    name: 'Documents',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'RESUME',
                        name: 'Resume',
                      },
                      value: 'https://link-to-the-document.com',
                    },
                  ],
                },
              ],
            },
            contact: {
              phone: '9999999999',
              email: 'abc@abc.bc',
            },
          },
          tags: [
            {
              descriptor: {
                code: 'DISTRIBUTOR_DETAILS',
                name: 'Distributor Details',
              },
              list: [
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_ID',
                    name: 'Distributor Id',
                  },
                  value: 'PNB',
                },
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_NAME',
                    name: 'Distributor Name',
                  },
                  value: 'Pay Near By',
                },
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_PHONE',
                    name: 'Distributor Phone',
                  },
                  value: '9123456789',
                },
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_EMAIL',
                    name: 'Distributor Email',
                  },
                  value: 'support@pnb.com',
                },
                {
                  descriptor: {
                    code: 'AGENT_ID',
                    name: 'Agent Id',
                  },
                  value: 'agent-123',
                },
                {
                  descriptor: {
                    code: 'AGENT_VERIFIED',
                    name: 'Agent Verified',
                  },
                  value: 'true',
                },
              ],
            },
          ],
        },
      ],
      payments: {
        url: 'https://ondc.transaction.com/payment',
        params: {
          currency: 'INR',
          transaction_id: '3937',
          amount: '1700.00',
        },
        status: 'PAID',
        type: 'ON-ORDER',
        collected_by: 'BAP',
        tags: {
          descriptor: {
            code: 'SETTLEMENT_DETAILS',
          },
          list: [
            {
              descriptor: {
                code: 'SETTLEMENT_COUNTERPARTY',
              },
              value: 'seller-app',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_PHASE',
              },
              value: 'sale-amount',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_TYPE',
              },
              value: 'upi',
            },
            {
              descriptor: {
                code: 'UPI_ADDRESS',
              },
              value: 'gft@oksbi',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_BANK_ACCOUNT_NO',
              },
              value: 'XXXXXXXXXX',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_IFSC_CODE',
              },
              value: 'XXXXXXXXX',
            },
            {
              descriptor: {
                code: 'BENEFICIARY_NAME',
              },
              value: 'xxxxx',
            },
            {
              descriptor: {
                code: 'BANK_NAME',
              },
              value: 'xxxx',
            },
            {
              descriptor: {
                code: 'BRANCH_NAME',
              },
              value: 'xxxx',
            },
          ],
        },
      },
    },
  },
};

export const jobStatusResponse = {
  context: {
    domain: 'ONDC:ONEST10',
    action: 'on_status',
    version: '2.0.0',
    bap_id: 'worker-hub.bap.io',
    bap_uri: 'https://worker-hub.bap.io',
    bpp_id: 'job-hub.bpp.io',
    bpp_uri: 'https://job-hub.bpp.io',
    transaction_id: 'a9aaecca-10b7-4d19-b640-b047a7c62195',
    message_id: 'c8e3968c-cd78-4e46-aa34-0d541e46bd73',
    location: {
      city: {
        code: 'std:080',
      },
      country: {
        code: 'IND',
      },
    },
    timestamp: '2023-02-22T11:50:46.742Z',
    ttl: 'PT30S',
  },
  message: {
    order: {
      id: '1677140405881',
      status: 'Active',
      provider: {
        id: '1',
      },
      items: [
        {
          id: '0253719F295521CED39EC9C2F3C8DCDE',
          fulfillment_ids: ['1'],
          time: {
            range: {
              start: '2025-01-03T13:23:01+00:00',
              end: '2025-05-03T13:23:01+00:00',
            },
          },
          tags: [
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '1',
                },
              ],
            },
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '2',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_NAME',
                    name: 'Name of the course',
                  },
                  value: 'Class-X',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_NAME',
                    name: 'Name of the course',
                  },
                  value: 'Class-XII',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_LEVEL',
                    name: 'Level of the course',
                  },
                  value: 'Under Graduate',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum percentage of marks to be obtained in the course for eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_LEVEL',
                    name: 'Level of the course',
                  },
                  value: 'Graduate',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'false',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_REQUIREMENTS',
                name: 'Job requirements',
              },
              list: [
                {
                  descriptor: {
                    code: 'REQ_EXPERIENCE',
                    name: 'Required work experience in years',
                  },
                  value: 'P2Y6M',
                },
                {
                  descriptor: {
                    code: 'ADD_PROF_SKILL',
                    name: 'Skills required for the role',
                  },
                  value: 'android-development',
                },
                {
                  descriptor: {
                    code: 'ADD_PROF_SKILL',
                    name: 'Skills required for the role',
                  },
                  value: 'dev-ops',
                },
                {
                  descriptor: {
                    code: 'ADD_PROF_SKILL',
                    name: 'Additional skills required for the job',
                  },
                  value:
                    'You have 8+ years of engineering experience, predominantly in shipping user-facing production features',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_RESPONSIBILITIES',
                name: 'Job responsibilities',
              },
              list: [
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Build frontend experiences for our tools (Web, PWA and React Native)',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Articulate a long term technical direction and vision for building, maintaining, and scaling our web and mobile platforms',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Create trustworthy user experiences by building interfaces that are simple, easy to comprehend, performant and reliable using modern tools like React, React Native, Typescript, Node.js, Jest and Webpack.',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Mentor and train other team members on design techniques and coding standards.',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_DETAILS',
                name: 'Listing details',
              },
              list: [
                {
                  descriptor: {
                    code: 'INDUSTRY_TYPE',
                    name: 'Industry type',
                  },
                  value: 'IT Services & Consulting',
                },
                {
                  descriptor: {
                    code: 'DEPARTMENT',
                    name: 'Department',
                  },
                  value: 'Engineering - Software & QA',
                },
                {
                  descriptor: {
                    code: 'CTC',
                    name: 'Salary Offered',
                  },
                  value: '20,00,000',
                },
                {
                  descriptor: {
                    code: 'POST_START_LOCATION',
                    name: 'Post start location',
                  },
                  value: 'Pune',
                },
                {
                  descriptor: {
                    code: 'WORKING_LOCATION',
                    name: 'Working location',
                  },
                  value: 'Hybrid',
                },
                {
                  descriptor: {
                    code: 'WORKING_TIME',
                    name: 'Working hours',
                  },
                  value: 'Full-Time',
                },
              ],
            },
          ],
        },
      ],
      quote: {
        price: {
          currency: 'INR',
          value: '1100',
        },
        breakup: [
          {
            id: '0253719F295521CED39EC9C2F3C8DCDE',
            price: {
              currency: 'INR',
              value: '1100',
            },
            title: 'Fullstack Engineer',
            tags: [
              {
                descriptor: {
                  code: 'TYPE',
                },
                list: [
                  {
                    descriptor: {
                      code: 'TYPE',
                    },
                    value: 'item',
                  },
                ],
              },
            ],
          },
        ],
        ttl: 'P1D',
      },
      fulfillments: [
        {
          id: '1',
          type: 'lead',
          state: {
            descriptor: {
              code: 'APPLICATION_IN_PROGRESS',
              name: 'Application In Progress',
            },
            updated_at: '2023-02-22T11:50:46.742Z',
          },
          customer: {
            person: {
              name: 'Sanjay',
              gender: 'Male',
              age: '35',
              skills: [
                {
                  code: 'Android',
                  name: 'Android',
                },
                {
                  code: 'AWS',
                  name: 'AWS',
                },
              ],
              languages: [
                {
                  code: 'en',
                  name: 'english',
                },
                {
                  code: 'ml',
                  name: 'Malayalam',
                },
                {
                  code: 'hi',
                  name: 'Hindi',
                },
              ],
              tags: [
                {
                  descriptor: {
                    code: 'EMP_DETAILS',
                    name: 'Employee Details',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'EXPECTED_SALARY',
                        name: 'Expected Salary',
                      },
                      value: '1000000',
                    },
                    {
                      descriptor: {
                        code: 'TOTAL_EXPERIENCE',
                        name: 'Total Experience',
                      },
                      value: 'P4Y',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS',
                    name: 'Documents',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DOC_TYPE',
                        name: 'Document Type',
                      },
                      value: 'resume',
                    },
                    {
                      descriptor: {
                        code: 'LINK',
                        name: 'Document Link',
                      },
                      value: 'https://example.com/resume.pdf',
                    },
                    {
                      descriptor: {
                        code: 'FILE_FORMAT',
                        name: 'File Format',
                      },
                      value: 'pdf',
                    },
                  ],
                },
              ],
            },
            contact: {
              phone: '9999999999',
              email: 'abc@abc.bc',
            },
          },
        },
      ],
      payments: {
        url: 'https://ondc.transaction.com/payment',
        params: {
          currency: 'INR',
          transaction_id: '3937',
          amount: '1700.00',
        },
        status: 'PAID',
        type: 'ON-ORDER',
        collected_by: 'BAP',
        tags: {
          descriptor: {
            code: 'SETTLEMENT_DETAILS',
          },
          list: [
            {
              descriptor: {
                code: 'SETTLEMENT_COUNTERPARTY',
              },
              value: 'seller-app',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_PHASE',
              },
              value: 'sale-amount',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_TYPE',
              },
              value: 'upi',
            },
            {
              descriptor: {
                code: 'UPI_ADDRESS',
              },
              value: 'gft@oksbi',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_BANK_ACCOUNT_NO',
              },
              value: 'XXXXXXXXXX',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_IFSC_CODE',
              },
              value: 'XXXXXXXXX',
            },
            {
              descriptor: {
                code: 'BENEFICIARY_NAME',
              },
              value: 'xxxxx',
            },
            {
              descriptor: {
                code: 'BANK_NAME',
              },
              value: 'xxxx',
            },
            {
              descriptor: {
                code: 'BRANCH_NAME',
              },
              value: 'xxxx',
            },
          ],
        },
      },
    },
  },
};

export const jobCancelResponse = {
  context: {
    domain: 'ONDC:ONEST10',
    action: 'on_cancel',
    version: '2.0.0',
    bap_id: 'worker-hub.bap.io',
    bap_uri: 'https://worker-hub.bap.io',
    bpp_id: 'job-hub.bpp.io',
    bpp_uri: 'https://job-hub.bpp.io',
    transaction_id: 'a9aaecca-10b7-4d19-b640-b047a7c62195',
    message_id: '8cbb5e99-5d06-4855-81e9-a4fc8013dbff',
    location: {
      city: {
        code: 'std:080',
      },
      country: {
        code: 'IND',
      },
    },
    timestamp: '2023-02-23T08:20:06Z',
    ttl: 'PT30S',
  },
  message: {
    order: {
      id: '1677140405881',
      status: 'Cancelled',
      provider: {
        id: '1',
      },
      items: [
        {
          id: '0253719F295521CED39EC9C2F3C8DCDE',
          fulfillment_ids: ['1', 'C1'],
          time: {
            range: {
              start: '2025-01-03T13:23:01+00:00',
              end: '2025-05-03T13:23:01+00:00',
            },
          },
          tags: [
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '1',
                },
              ],
            },
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '2',
                },
              ],
            },
            {
              descriptor: {
                code: 'CANCEL_REQUEST',
                name: 'Cancel request',
              },
              list: [
                {
                  descriptor: {
                    code: 'REASON_ID',
                    name: 'Reason id',
                  },
                  value: '001',
                },
                {
                  descriptor: {
                    code: 'INITIATED_BY',
                    name: 'Initiated by',
                  },
                  value: 'Subscriber ID',
                },
              ],
            },
          ],
        },
      ],
      quote: {
        price: {
          currency: 'INR',
          value: '0',
        },
        breakup: [
          {
            id: '0253719F295521CED39EC9C2F3C8DCDE',
            price: {
              currency: 'INR',
              value: '0',
            },
            title: 'Fullstack Engineer',
            tags: [
              {
                descriptor: {
                  code: 'TYPE',
                },
                list: [
                  {
                    descriptor: {
                      code: 'TYPE',
                    },
                    value: 'item',
                  },
                ],
              },
            ],
          },
        ],
        ttl: 'P1D',
      },
      fulfillments: [
        {
          id: '1',
          type: 'lead',
          state: {
            descriptor: {
              code: 'CANCELLED',
            },
          },
          customer: {
            person: {
              name: 'Sanjay',
              gender: 'Male',
              age: '35',
              skills: [
                {
                  code: 'Android',
                  name: 'Android',
                },
                {
                  code: 'AWS',
                  name: 'AWS',
                },
              ],
              languages: [
                {
                  code: 'en',
                  name: 'english',
                },
                {
                  code: 'ml',
                  name: 'Malayalam',
                },
                {
                  code: 'hi',
                  name: 'Hindi',
                },
              ],
              tags: [
                {
                  descriptor: {
                    code: 'CURRENT_EXPERIENCE',
                    name: 'Current Experience',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'EXP_YEARS',
                        name: 'Experience',
                      },
                      value: 'P4Y2M',
                    },
                    {
                      descriptor: {
                        code: 'CURRENT_COMPANY',
                        name: 'Current Company',
                      },
                      value: 'ABC tech',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'SALARY_DETAILS',
                    name: 'Salary Details',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'EXPECTED_SALARY',
                        name: 'Expected Salary',
                      },
                      value: '80000',
                    },
                    {
                      descriptor: {
                        code: 'CURRENT_SALARY',
                        name: 'Current Salary',
                      },
                      value: '50000',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS',
                    name: 'Documents',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'RESUME',
                        name: 'Resume',
                      },
                      value: 'https://link-to-the-document.com',
                    },
                  ],
                },
              ],
            },
            contact: {
              phone: '9999999999',
              email: 'abc@abc.bc',
            },
          },
          tags: [
            {
              descriptor: {
                code: 'DISTRIBUTOR_DETAILS',
                name: 'Distributor Details',
              },
              list: [
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_ID',
                    name: 'Distributor Id',
                  },
                  value: 'PNB',
                },
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_NAME',
                    name: 'Distributor Name',
                  },
                  value: 'Pay Near By',
                },
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_PHONE',
                    name: 'Distributor Phone',
                  },
                  value: '9123456789',
                },
                {
                  descriptor: {
                    code: 'DISTRIBUTOR_EMAIL',
                    name: 'Distributor Email',
                  },
                  value: 'support@pnb.com',
                },
                {
                  descriptor: {
                    code: 'AGENT_ID',
                    name: 'Agent Id',
                  },
                  value: 'agent-123',
                },
                {
                  descriptor: {
                    code: 'AGENT_VERIFIED',
                    name: 'Agent Verified',
                  },
                  value: 'true',
                },
              ],
            },
          ],
        },
        {
          id: 'C1',
          tags: [
            {
              descriptor: {
                code: 'QUOTE_TRAIL',
              },
              list: [
                {
                  descriptor: {
                    code: 'CURRENCY',
                  },
                  value: 'INR',
                },
                {
                  descriptor: {
                    code: 'ID',
                  },
                  value: '0253719F295521CED39EC9C2F3C8DCDE',
                },
                {
                  descriptor: {
                    code: 'TYPE',
                  },
                  value: 'ITEM',
                },
                {
                  descriptor: {
                    code: 'VALUE',
                  },
                  value: '-1100.00',
                },
              ],
            },
          ],
        },
      ],
      payments: {
        url: 'https://ondc.transaction.com/payment',
        params: {
          currency: 'INR',
          transaction_id: '3937',
          amount: '1700.00',
        },
        status: 'PAID',
        type: 'ON-ORDER',
        collected_by: 'BAP',
        tags: {
          descriptor: {
            code: 'SETTLEMENT_DETAILS',
          },
          list: [
            {
              descriptor: {
                code: 'SETTLEMENT_COUNTERPARTY',
              },
              value: 'seller-app',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_PHASE',
              },
              value: 'sale-amount',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_TYPE',
              },
              value: 'upi',
            },
            {
              descriptor: {
                code: 'UPI_ADDRESS',
              },
              value: 'gft@oksbi',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_BANK_ACCOUNT_NO',
              },
              value: 'XXXXXXXXXX',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_IFSC_CODE',
              },
              value: 'XXXXXXXXX',
            },
            {
              descriptor: {
                code: 'BENEFICIARY_NAME',
              },
              value: 'xxxxx',
            },
            {
              descriptor: {
                code: 'BANK_NAME',
              },
              value: 'xxxx',
            },
            {
              descriptor: {
                code: 'BRANCH_NAME',
              },
              value: 'xxxx',
            },
          ],
        },
      },
    },
  },
};
export const jobUpdateResponse = {
  context: {
    domain: 'ONDC:ONEST10',
    action: 'on_update',
    version: '2.0.0',
    bap_id: 'worker-hub.bap.io',
    bap_uri: 'https://worker-hub.bap.io',
    bpp_id: 'job-hub.bpp.io',
    bpp_uri: 'https://job-hub.bpp.io',
    transaction_id: 'a9aaecca-10b7-4d19-b640-b047a7c62195',
    message_id: '8cbb5e99-5d06-4855-81e9-a4fc8013dbff',
    location: {
      city: {
        code: 'std:080',
      },
      country: {
        code: 'IND',
      },
    },
    timestamp: '2023-02-23T08:20:061Z',
    ttl: 'PT30S',
  },
  message: {
    order: {
      id: '1677140405881',
      status: 'Active',
      provider: {
        id: '1',
      },
      items: [
        {
          id: 'a23f2fdfbbb8ac402bf259d75402eb0792f50c095f7d08a55475e7af1c2dadca',
          fulfillment_ids: ['1'],
          location_ids: ['L1'],
          tags: [
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '1',
                },
              ],
            },
            {
              descriptor: {
                code: 'NP_FEES',
                name: 'Np Fees',
              },
              list: [
                {
                  code: 'ID',
                  value: '2',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_NAME',
                    name: 'Name of the Course',
                  },
                  value: 'Class-X',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum Percentage of Marks for Eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_NAME',
                    name: 'Name of the Course',
                  },
                  value: 'Class-XII',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum Percentage of Marks for Eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_LEVEL',
                    name: 'Level of the Course',
                  },
                  value: 'Under Graduate',
                },
                {
                  descriptor: {
                    code: 'MIN_PERCENTAGE',
                    name: 'Minimum Percentage of Marks for Eligibility',
                  },
                  value: '60',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'true',
                },
              ],
            },
            {
              descriptor: {
                code: 'ACADEMIC_ELIGIBILITY',
                name: 'Academic Eligibility',
              },
              list: [
                {
                  descriptor: {
                    code: 'COURSE_LEVEL',
                    name: 'Level of the Course',
                  },
                  value: 'Graduate',
                },
                {
                  descriptor: {
                    code: 'MANDATORY_ELIGIBILITY',
                    name: 'Mandatory Eligibility',
                  },
                  value: 'false',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_REQUIREMENTS',
                name: 'Job Requirements',
              },
              list: [
                {
                  descriptor: {
                    code: 'REQ_EXPERIENCE',
                    name: 'Required Work Experience in Years',
                  },
                  value: 'P2Y6M',
                },
                {
                  descriptor: {
                    code: 'ADD_PROF_SKILL',
                    name: 'Skills Required for the Role',
                  },
                  value: 'android-development',
                },
                {
                  descriptor: {
                    code: 'ADD_PROF_SKILL',
                    name: 'Skills Required for the Role',
                  },
                  value: 'dev-ops',
                },
                {
                  descriptor: {
                    code: 'REQ_ADDL_SKILL',
                    name: 'Additional Skills Required for the Job',
                  },
                  value:
                    '8+ years of engineering experience in shipping user-facing production features',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_RESPONSIBILITIES',
                name: 'Job Responsibilities',
              },
              list: [
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Build frontend experiences for tools (Web, PWA, React Native)',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value: 'Define long-term technical direction and vision',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Create reliable interfaces using modern tools like React, React Native, Typescript, Node.js, Jest, and Webpack.',
                },
                {
                  descriptor: {
                    code: 'RESPONSIBILITY',
                    name: 'Responsibility',
                  },
                  value:
                    'Mentor team members on design techniques and coding standards.',
                },
              ],
            },
            {
              descriptor: {
                code: 'JOB_DETAILS',
                name: 'Listing Details',
              },
              list: [
                {
                  descriptor: {
                    code: 'INDUSTRY_TYPE',
                    name: 'Industry Type',
                  },
                  value: 'IT Services & Consulting',
                },
                {
                  descriptor: {
                    code: 'DEPARTMENT',
                    name: 'Department',
                  },
                  value: 'Engineering - Software & QA',
                },
                {
                  descriptor: {
                    code: 'EMPLOYMENT_TYPE',
                    name: 'Employment Type',
                  },
                  value: 'Full-Time',
                },
                {
                  descriptor: {
                    code: 'JOB_ROLE',
                    name: 'Job Role',
                  },
                  value: 'DevOps Engineer',
                },
              ],
            },
          ],
        },
      ],
      fulfillments: [
        {
          id: '1',
          type: 'lead',
          customer: {
            person: {
              name: 'Sanjay',
              gender: 'Male',
              age: '35',
              skills: [
                {
                  code: 'Android',
                  name: 'Android',
                },
                {
                  code: 'AWS',
                  name: 'AWS',
                },
              ],
              languages: [
                {
                  code: 'en',
                  name: 'english',
                },
                {
                  code: 'ml',
                  name: 'Malayalam',
                },
                {
                  code: 'hi',
                  name: 'Hindi',
                },
              ],
              tags: [
                {
                  descriptor: {
                    code: 'EMP_DETAILS',
                    name: 'Employee Details',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'EXPECTED_SALARY',
                        name: 'Expected Salary',
                      },
                      value: '1000000',
                    },
                    {
                      descriptor: {
                        code: 'TOTAL_EXPERIENCE',
                        name: 'Total Experience',
                      },
                      value: 'P4Y',
                    },
                  ],
                },
                {
                  descriptor: {
                    code: 'DOCUMENTS',
                    name: 'Documents',
                  },
                  list: [
                    {
                      descriptor: {
                        code: 'DOC_TYPE',
                        name: 'Document Type',
                      },
                      value: 'resume',
                    },
                    {
                      descriptor: {
                        code: 'LINK',
                        name: 'Document Link',
                      },
                      value: 'https://example.com/resume.pdf',
                    },
                    {
                      descriptor: {
                        code: 'FILE_FORMAT',
                        name: 'File Format',
                      },
                      value: 'pdf',
                    },
                  ],
                },
              ],
            },
            contact: {
              phone: '9999999999',
              email: 'abc@abc.bc',
            },
          },
        },
      ],
      quote: {
        price: {
          currency: 'INR',
          value: '1100',
        },
        breakup: [
          {
            id: '0253719F295521CED39EC9C2F3C8DCDE',
            price: {
              currency: 'INR',
              value: '1100',
            },
            title: 'Fullstack Engineer',
            tags: [
              {
                descriptor: {
                  code: 'TYPE',
                },
                list: [
                  {
                    descriptor: {
                      code: 'TYPE',
                    },
                    value: 'item',
                  },
                ],
              },
            ],
          },
        ],
        ttl: 'P1D',
      },
      payments: {
        url: 'https://ondc.transaction.com/payment',
        params: {
          currency: 'INR',
          transaction_id: '3937',
          amount: '1700.00',
        },
        status: 'PAID',
        type: 'ON-ORDER',
        collected_by: 'BAP',
        tags: {
          descriptor: {
            code: 'SETTLEMENT_DETAILS',
          },
          list: [
            {
              descriptor: {
                code: 'SETTLEMENT_COUNTERPARTY',
              },
              value: 'seller-app',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_PHASE',
              },
              value: 'sale-amount',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_TYPE',
              },
              value: 'upi',
            },
            {
              descriptor: {
                code: 'UPI_ADDRESS',
              },
              value: 'gft@oksbi',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_BANK_ACCOUNT_NO',
              },
              value: 'XXXXXXXXXX',
            },
            {
              descriptor: {
                code: 'SETTLEMENT_IFSC_CODE',
              },
              value: 'XXXXXXXXX',
            },
            {
              descriptor: {
                code: 'BENEFICIARY_NAME',
              },
              value: 'xxxxx',
            },
            {
              descriptor: {
                code: 'BANK_NAME',
              },
              value: 'xxxx',
            },
            {
              descriptor: {
                code: 'BRANCH_NAME',
              },
              value: 'xxxx',
            },
          ],
        },
      },
    },
  },
};

export const helpFormResponse = {
  context: {
    domain: 'ONDC:RET10',
    location: {
      country: {
        code: 'IND',
      },
      city: {
        code: '*',
      },
    },
    action: 'on_issue',
    core_version: '2.0.0',
    bap_id: 'buyerapp.com',
    bap_uri: 'https://buyerapp.com/ondc',
    bpp_id: 'sellerapp.com',
    bpp_uri: 'https://sellerapp.com/ondc',
    transaction_id: 'T1',
    message_id: 'M1',
    timestamp: '2023-01-15T10:00:00.469Z',
    ttl: 'PT30S',
  },
  message: {
    upated_target: [
      {
        path: 'issue.actions',
        action: 'APPENDED',
      },
    ],
    issue: {
      id: 'ISSUE-1',
      status: 'PROCESSING',
      level: 'ISSUE',
      created_at: '2023-01-15T10:00:00.469Z',
      updated_at: '2023-01-15T10:00:00.469Z',
      expected_response_time: {
        duration: 'PT2H',
      },
      expected_resolution_time: {
        duration: 'P1D',
      },
      refs: [
        {
          ref_id: 'O1',
          ref_type: 'ORDER',
        },
        {
          ref_id: 'P1',
          ref_type: 'PROVIDER',
        },
        {
          ref_id: 'F1',
          ref_type: 'FULFILMENT',
        },
        {
          ref_id: 'I1',
          ref_type: 'ITEM',
          tags: [
            {
              descriptor: {
                code: 'message.order.items',
              },
              list: [
                {
                  descriptor: {
                    code: 'quantity.selected.count',
                  },
                  value: '2',
                },
              ],
            },
          ],
        },
      ],
      actor_info: [
        {
          id: 'CUST1',
          type: 'CONSUMER',
          info: {
            org: {
              name: 'buyerapp.com::ONDC:RET10',
            },
            person: {
              name: 'Sam Manuel',
            },
            contact: {
              phone: '9879879870',
              email: 'sam@yahoo.com',
            },
          },
        },
        {
          id: 'NP1',
          type: 'INTERFACING-NP',
          info: {
            org: {
              name: 'buyerapp.com::ONDC:RET10',
            },
            contact: {
              phone: '9450394039',
              email: 'buyerapp@interface.com',
            },
            person: {
              name: 'John Doe',
            },
          },
        },
        {
          id: 'NP2',
          type: 'TRANSACTION-COUNTERPARTY-NP',
          info: {
            org: {
              name: 'sellerapp.com::ONDC:RET10',
            },
            contact: {
              phone: '9450394140',
              email: 'respondentapp@respond.com',
            },
            person: {
              name: 'Jane Doe',
            },
          },
        },
      ],
      source_id: 'CUST1',
      complainant_id: 'NP1',
      respondent_ids: ['NP2'],
      description: {
        code: 'ITM004',
        short_desc: 'Issue with product quality',
        long_desc:
          'product quality is not correct. facing issues while using the product',
        additional_desc: {
          url: 'https://buyerapp.com/additonal-details/desc.txt',
          content_type: 'text/plain',
        },
        images: [
          'data:image/jpeg;base64,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',
          'data:image/jpeg;base64,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',
        ],
      },
      last_action_id: 'A2',
      actions: [
        {
          id: 'A1',
          description: {
            code: 'OPEN',
            short_desc: 'Complaint created',
          },
          updated_at: '2023-01-15T10:00:00.469Z',
          action_by: 'NP1',
          actor_details: {
            name: 'Sam Manuel',
          },
        },
        {
          id: 'A2',
          description: {
            code: 'PROCESSING',
            short_desc: 'Complaint created',
          },
          updated_at: '2023-01-15T10:00:10.469Z',
          action_by: 'NP1',
          actor_details: {
            name: 'Sam Manuel',
          },
        },
      ],
    },
  },
};

export const onSettleJobResponse = {
  "action": "settle",
  "error": null,
  "request_payload": {
    "context": {
      "action": "settle",
      "bap_id": "skill-mantra-ondc.samhita.org",
      "bap_uri": "https://skill-mantra-ondc.samhita.org/",
      "bpp_id": "job-hub.bpp.io",
      "bpp_uri": "https://job-hub.bpp.io",
      "domain": "ONDC:ONEST10",
      "location": {
        "city": {
          "code": "*"
        },
        "country": {
          "code": "IND"
        }
      },
      "message_id": "c3a11b63-031a-4df7-bc9d-eb78b220b515",
      "timestamp": "2025-01-17T07:28:46.059120Z",
      "transaction_id": "cb9c9984-0655-40bd-84fb-d92cdb6a4abb",
      "ttl": "P1D",
      "version": "2.0.0"
    },
    "message": {
      "collector_app_id": "skill-mantra-ondc.samhita.org",
      "receiver_app_id": "job-hub.bpp.io",
      "settlement": {
        "id": "56ac1a23-4fd6-4e96-b1ab-4a5c96631e3a",
        "orders": [
          {
            "collector": {
              "amount": {
                "currency": "INR",
                "value": 50
              }
            },
            "id": "0253719F295521CED39EC9C2F3C8DCDE",
            "inter_participant": {
              "amount": {
                "currency": "INR",
                "value": 1050
              }
            },
            "self": {
              "amount": {
                "currency": "INR",
                "value": 50
              }
            }
          }
        ],
        "type": "NP-NP"
      }
    }
  },
  "request_timestamp": "Fri, 17 Jan 2025 07:29:04 GMT",
  "response_payload": {
    "context": {
      "action": "on_settle",
      "bap_id": "skill-mantra-ondc.samhita.org",
      "bap_uri": "https://skill-mantra-ondc.samhita.org/",
      "bpp_id": "rsf-mock-service.ondc.org/seller_protocol_server",
      "bpp_uri": "https://rsf-mock-service.ondc.org/seller_protocol_server",
      "domain": "ONDC:NTS10",
      "location": {
        "city": {
          "code": "*"
        },
        "country": {
          "code": "IND"
        }
      },
      "message_id": "c3a11b63-031a-4df7-bc9d-eb78b220b515",
      "timestamp": "2025-01-17T07:31:47.855Z",
      "transaction_id": "cb9c9984-0655-40bd-84fb-d92cdb6a4abb",
      "ttl": "PT10M",
      "version": "2.0.0"
    },
    "message": {
      "collector_app_id": "skill-mantra-ondc.samhita.org",
      "receiver_app_id": "job-hub.bpp.io",
      "settlement": {
        "id": "56ac1a23-4fd6-4e96-b1ab-4a5c96631e3a",
        "orders": [
          {
            "collector": {
              "amount": {
                "currency": "INR",
                "value": 50
              }
            },
            "id": "0253719F295521CED39EC9C2F3C8DCDE",
            "inter_participant": {
              "amount": {
                "currency": "INR",
                "value": 1050
              },
              "reference_no": "1238683618634",
              "settled_amount": {
                "currency": "INR",
                "value": 1050
              },
              "status": "UN_SETTLED"
            },
            "self": {
              "amount": {
                "currency": "INR",
                "value": 50
              },
              "reference_no": "1238683618634",
              "status": "SETTLED"
            }
          }
        ],
        "type": "NP-NP"
      }
    }
  },
  "response_timestamp": "Fri, 17 Jan 2025 07:31:48 GMT",
  "status": "COMPLETED"
}
